import { browserHistory } from 'react-router';
import { arrayPush, reset } from 'redux-form';

import * as api from '../../services/item/apiItem';
import * as apiCommon from '../../services/apiCommon';
import {
  GET_ITEM_LOCATIONS,
  GET_ITEM_UOMS,
  SET_ITEM_LOCATION,
} from '../../constants/constant_action_types';
import {
  ADD_BARCODE_TO_LIST,
  ADD_QRCODE_TO_LIST,
} from '../../constants/constant_saga_types';

import { ItemAddForm } from '../../constants/constant_form_names';

import * as common from '../sagasCommon';
import { delay, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import * as DocType from '../../constants/constant_doc_types';
import * as sectionTableActions from '../../components/common/form/SectionTable/actions';
import { getPreferenceSettings } from '../../actions/actionCreatorsAdmin';
import { getErrorMessage } from '../../utils';

export function* deleteItemSaga(feathersApp) {
  yield takeEvery('DELETE_ITEM', callDeleteItem, feathersApp);
}

export function* deleteItemFromListSaga(feathersApp) {
  yield takeEvery('DELETE_ITEM_FROM_LIST', callDeleteItemFromList, feathersApp);
}

export function* fetchListItemSaga(feathersApp) {
  yield takeLatest('FETCH_LIST_ITEM', callFetchListItem, feathersApp);
}

export function* fetchItemForEditSaga(feathersApp) {
  yield takeEvery('FETCH_ITEM_FOR_EDIT', callFetchItemForEdit, feathersApp);
}

export function* saveItemSaga(feathersApp) {
  yield takeLatest('SAVE_ITEM', callSaveItem, feathersApp);
}

export function* addBarcodetoListSaga(feathersApp) {
  yield takeLatest(ADD_BARCODE_TO_LIST, callAddBarcodetoListSaga, feathersApp);
}

export function* addQRcodetoListSaga(feathersApp) {
  yield takeLatest(ADD_QRCODE_TO_LIST, callAddQRcodetoListSaga, feathersApp);
}

function* callFetchListItem(feathersApp, action) {
  const { filters, silent } = action;
  yield common.showProgressListTable(silent);
  try {
    const dataParams = {
      filters,
      list_type: 'item',
    };
    const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
    yield call(common.doneListTable, {
      rows: tableData.data,
      total_rows: tableData.total,
    });
  } catch (error) {
    yield common.showErrorListTable(error);
  }
}

function* callDeleteItemFromList(feathersApp, action) {
  yield deleteItem(feathersApp, action);
  yield delay(2000);
  yield callFetchListItem(feathersApp, { silent: true });
}

function* callDeleteItem(feathersApp, action) {
  const result = yield deleteItem(feathersApp, action);
  yield delay(2000);
  if (result) {
    browserHistory.push('/admin/item');
  }
}

function* deleteItem(feathersApp, action) {
  yield put({ type: 'DELETE_RECORD_INPROGRESS' });
  try {
    const { id } = action;
    let result = null;
    if (id) {
      const { tenant, user } = yield select();
      const { id } = action;
      const params = { tenant, user, id };
      result = yield call(api.deleteItem, feathersApp, params);
      yield put({
        type: 'DELETE_RECORD_DONE',
        payload: { id, docType: DocType.ITEM },
      });
    }
    return result;
  } catch (error) {
    yield common.showErrorDeleteRecord(error);
  }
}

function* callSaveItem(feathersApp, action) {
  yield common.showProgressSaveRecord();

  const { tenant, user, item_uom } = yield select();
  let data = { ...action.data };

  if (data) {
    try {
      const isQuickAdd = data.fromQuickAdd ? data.fromQuickAdd : false;
      data.item_locations = data.item_locations || [];

      delete data.item_locations;
      delete data.fromQuickAdd;
      data.item_uoms = item_uom.list;
      let saveParams = { tenant, user, data: action.data };
      let saveItemResult = yield call(api.saveItem, feathersApp, saveParams);

      if (saveItemResult) {
        const itemId = saveItemResult && saveItemResult.id;

        if (isQuickAdd) {
          console.log('callSaveItem redirecting to edit screen');
          yield common.doneSaveRecord(saveItemResult);
          yield put({
            type: 'SAVE_RECORD_NEW_DONE',
            result: { ...saveItemResult },
          });
          browserHistory.push(`/admin/item/edit/${itemId}`);
          return;
        }

        yield call(
          callFetchItemForEdit,
          feathersApp,
          { id: itemId, silent: true },
          action.intl
        );
        browserHistory.push(`/admin/item/edit/${itemId}`);
        yield common.doneSaveRecord(saveItemResult, 'Item was saved');
        // Force reset after saving
        // This is to avoid dirty form when keepDirtyOnReinitialize is true
        yield put(reset(ItemAddForm));
      }
    } catch (error) {
      console.error('error', error.stack);
      yield common.showErrorSaveRecord(error);
    }
  }
}

function* callFetchItemForEdit(feathersApp, action) {
  const { path } = yield select();
  const { id, silent } = action;

  const itemLocFilters = { item: id, include_tax_rate: true };

  try {
    let data;

    if (id) {
      yield common.showProgressDataById(silent);
      yield put(getPreferenceSettings(['enable_item_part_quantity']));
      yield put({ type: GET_ITEM_LOCATIONS, filters: itemLocFilters });
      yield put({ type: GET_ITEM_UOMS, filters: { item: id } });

      const params = { id, path };
      const doc = yield call(api.fetchItemById, feathersApp, params);

      /**
       * Set item location form, for listing item locations.
       */
      yield put({ type: SET_ITEM_LOCATION, data: doc });

      data = doc;
    } else {
      const initialValue = {
        item_type_id: 'inventory',
      };

      data = initialValue;
    }

    yield common.doneDataById(data);
  } catch (error) {
    yield common.showErrorDataById(error);
  }
}

function* callAddBarcodetoListSaga(feathersApp, action) {
  try {
    const { barcode } = action;
    yield call(api.validateBarcode, feathersApp, { barcode });
    yield put(arrayPush(ItemAddForm, 'barcodes', { barcode }));
    yield common.clearSaveRecord();
  } catch (error) {
    yield common.showErrorSaveRecord(error);
  }
}

function* callAddQRcodetoListSaga(feathersApp, action) {
  try {
    const { qrcode } = action;
    yield call(api.validateQRcode, feathersApp, { qrcode });
    yield put(arrayPush(ItemAddForm, 'qrcodes', { qrcode }));
    yield common.clearSaveRecord();
  } catch (error) {
    yield common.showErrorSaveRecord(error);
  }
}

export function* getItemHotkeyGroups(app) {
  yield takeEvery('GET_ITEM_HOTKEY_GROUPS', callGetItemHotkeyGroups, app);
}

function* callGetItemHotkeyGroups(app, action) {
  const { key, payload } = action;
  yield put(sectionTableActions.setSectionTableLoader(key, true));

  try {
    const { data, total, limit, skip } = yield call(apiCommon.getDocs, app, {
      ...payload,
      filters: {
        ...payload.filters,
      },
      list_type: 'hotkey_group',
    });

    const meta = {
      total,
      limit,
      skip,
    };

    yield put(sectionTableActions.setSectionTableData(key, { data, meta }));
  } catch (err) {
    yield put(sectionTableActions.setSectionTableError(key, true, getErrorMessage(err)));
  }
}
